module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wizardWrapper"
  }, [_c('el-row', {
    attrs: {
      "gutter": 2
    }
  }, [(_vm.loading) ? _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('p', [(_vm.isZNB) ? _c('span', [_vm._v(_vm._s(_vm.$t('static.orders.orderConfirm.znbTitle')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('static.orders.orderConfirm.title')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24
    }
  }, [_c('h3', {
    staticClass: "wizardTitle"
  }, [(_vm.isZNB) ? _c('span', [_vm._v(_vm._s(_vm.$t('static.orders.orderConfirm.znbTitle')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('static.orders.orderConfirm.title')))])]), _vm._v(" "), (_vm.hasExciseModule) ? _c('div', [(_vm.bevearageProducts.length) ? [_c('p', [_vm._v(_vm._s(_vm.$t('static.orders.orderConfirm.clientType')) + ": " + _vm._s(_vm.currentOrder.client.clientType.name) + "\n                "), (_vm.currentOrder.client && _vm.currentOrder.client.clientType.exciseAdditionalCode) ? [_c('br'), _vm._v(_vm._s(_vm.$t('static.orders.orderConfirm.exciseCode')) + ": " + _vm._s(_vm.currentOrder.client.clientType.exciseAdditionalCode) + "\n                ")] : _vm._e()], 2), _vm._v(" "), (_vm.hasNoExcise) ? _c('el-alert', {
    staticStyle: {
      "margin-bottom": "10px",
      "margin-top": "15px",
      "display": "flex"
    },
    attrs: {
      "title": _vm.$t('static.orders.orderConfirm.exciseWarningMessage'),
      "type": "warning",
      "show-icon": "",
      "closable": false
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "el-row",
    staticStyle: {
      "border": "1px solid #ebeef5",
      "background": "#f4f3f3",
      "padding": "10px"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "display": "block"
    },
    attrs: {
      "data": _vm.bevearageProducts
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.orders.orderConfirm.table.product')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.noExcise || !scope.row.productPackaging) ? _c('a', {
          on: {
            "click": function($event) {
              return _vm.quickProductEdit(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        }), _vm._v(" " + _vm._s(scope.row.name))]) : _c('span', [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 4066193461)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.orders.orderConfirm.exciseCheck')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.noExcise) ? _c('i', {
          staticClass: "el-icon-circle-check success-color",
          staticStyle: {
            "font-size": "18px"
          }
        }) : _c('i', {
          staticClass: "el-icon-circle-close danger-color",
          staticStyle: {
            "font-size": "18px"
          }
        })]
      }
    }], null, false, 3082525749)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.orders.orderConfirm.packagingCheck')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.productPackaging) ? _c('i', {
          staticClass: "el-icon-circle-check success-color",
          staticStyle: {
            "font-size": "18px"
          }
        }) : _c('i', {
          staticClass: "el-icon-circle-close danger-color",
          staticStyle: {
            "font-size": "18px"
          }
        })]
      }
    }], null, false, 2695315936)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "beverage",
      "label": _vm.$t('static.orders.orderConfirm.table.exciseGroup.beverage')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "packaging",
      "label": _vm.$t('static.orders.orderConfirm.table.exciseGroup.packaging')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "basic",
      "label": _vm.$t('static.orders.orderConfirm.table.exciseGroup.basic')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bottleVolume",
      "label": _vm.$t('static.orders.orderConfirm.table.bottleVolume')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "alcoholPercentage",
      "label": _vm.$t('static.orders.orderConfirm.table.alcoholPercentage')
    }
  })], 1)], 1)] : _vm._e()], 2) : _c('div', [_c('el-alert', {
    staticStyle: {
      "margin-bottom": "10px",
      "margin-top": "15px",
      "display": "flex"
    },
    attrs: {
      "title": _vm.$t('static.orders.orderConfirm.upsellMessage'),
      "type": "info",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('div', [(!_vm.loading && !_vm.isZNB) ? _c('v-form', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "form": _vm.form,
      "translation": "form.orderConfirm",
      "hasLabel": true
    }
  }) : _vm._e()], 1)])], 1), _vm._v(" "), (!_vm.isZNB) ? [_c('el-button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.closeModal(_vm.dashboard)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    attrs: {
      "loading": _vm.form.loading,
      "disabled": !!(_vm.hasNoExcise || _vm.hasMissingPackaging)
    },
    on: {
      "click": _vm.store
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('button.save').toUpperCase()))])] : _c('div', {
    staticClass: "flex justify-center"
  }, [_c('el-button', {
    staticClass: "small margin-t-10",
    attrs: {
      "loading": _vm.form.loading,
      "disabled": !!(_vm.hasNoExcise || _vm.hasMissingPackaging)
    },
    on: {
      "click": _vm.nextProcess
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('button.next').toUpperCase()))])], 1)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fe63485","hasScoped":false}!./src/app/components/ediOrderConfirm/ediOrderConfirm.html
// module id = 3060
// module chunks = 1